import "./CommonUiOverlayComponent.css"

import MouseLabel from "../text-components/MouseLabel";
import EditHandleTooltipOverlay from "../text-components/EditHandleTooltipOverlay";
import RoomNoteTooltipOverlay from "../text-components/RoomNoteTooltipOverlay";
import CrosshairPreloader from "../ui/CrosshairPreloader";
import LanguageSelector from "../LanguageSelector";
import Constants from '../../constants';
import CurrentCommandComponent from './CurrentCommandComponent';
import GenericDialogComponent from './GenericDialogComponent';
import TextAnnotationDialogComponent from './TextAnnotationDialogComponent';
import RoomNoteDialogComponent from './RoomNoteDialogComponent';
import PropertiesPanelComponent from './PropertiesPanelComponent';
import SelectionContextToolbarComponent from './SelectionContextToolbarComponent';
import { buildTime } from '../../build-time';
import LoadingStateVisualizerComponent from "../geometry-components/LoadingStateVisualizerComponent";

import { ViewerModeEnum } from "../../store/viewerState/ViewerMode/ViewerMode";
import ViewerModeButtonComponent from "./ViewerModeButtonComponent";
import { useViewerStateStore } from "../../store/viewerStateStore";
import { useContext } from "react";
import { ConfigurationStateContext } from "../../store/configurationState/ConfigurationStateProvider";
import StoreySelectorComponent from "./StoreySelectorComponent";

const CommonUiOverlayComponent = () => {

    const { isDebugMode } = useViewerStateStore();
    const { configurationState } = useContext(ConfigurationStateContext);

    const buildTitle = () => {

        let title = `Version: ${Constants.VERSION_NO}`;

        if (isDebugMode) {
            title +=  `\r\nBuild time: ${buildTime}`  +
                      `\r\nAPI: ${configurationState.visualizerApiUrl}`;
        }

        return title;
    }

    return (
        <>
          <MouseLabel />
          <EditHandleTooltipOverlay />
          <RoomNoteTooltipOverlay />
          <CrosshairPreloader />

          <LanguageSelector />

          <div className="appTitle" title={buildTitle()}>
            <img className="appLogo" src="/icons/gbuilder-logo-black.svg" alt="GBuilder Logo" />
            Smart Floor Plan
          </div>

          <div className="currentCommand">
            <CurrentCommandComponent />
          </div>

          <GenericDialogComponent />
          <TextAnnotationDialogComponent />
          <RoomNoteDialogComponent />
          <PropertiesPanelComponent />

          <div className="loadingState">
            <LoadingStateVisualizerComponent />
          </div>

          <SelectionContextToolbarComponent />

          <div className="buttons">
              <ViewerModeButtonComponent mode={ViewerModeEnum.ApartmentSelect2d} nameResourceKey={"ui.viewMode.floorPlan.label"} />
              <ViewerModeButtonComponent mode={ViewerModeEnum.FreeRoam3d} nameResourceKey={"ui.viewMode.threeD.label"} />
              {/* <button  onClick={() => emitter.emit("viewerModeChange", ViewerModeEnum.ApartmentSelect2d ) }>{t("ui.viewMode.floorPlan.label")}</button>
              <button  onClick={() => emitter.emit("viewerModeChange", ViewerModeEnum.FreeRoam3d)}>{t("ui.viewMode.threeD.label")}</button> */}

              { isDebugMode && (
                <>
                <ViewerModeButtonComponent mode={ViewerModeEnum.Dollhouse} nameResourceKey={"ui.viewMode.dollhouse.label"} />
                  {/* <button  onClick={() => emitter.emit("viewerModeChange", ViewerModeEnum.Marketing)}>Inspect</button> */}
                  <ViewerModeButtonComponent mode={ViewerModeEnum.Marketing} nameResourceKey={"debug.viewerModeInspect"} />
                </>
              ) }
            </div>

          <StoreySelectorComponent />
        </>
    );
};

export default CommonUiOverlayComponent;  